import meaulist from '../components/menu'

export default {
  meaulistGet: function (that, option) {
    let path_ = that.$route.path;
    let list_sessionStorage = JSON.parse(sessionStorage.getItem("newnavMenu"));
    let nav_first = ''
    let nav_Option = ''
    for (let i in meaulist.meaulist) {
      if (path_.indexOf(meaulist.meaulist[i].url) !== -1) {
        nav_first = meaulist.meaulist[i].menuName
        for (let j in meaulist.meaulist[i].children) {
          if(meaulist.meaulist[i].children[j].url === path_){
            nav_Option = list_sessionStorage[nav_first].childs[meaulist.meaulist[i].children[j].menuName]
          }
        }
      }
    }
    // nav_Option
    let array_ = {}
    let firstTab = ''
    for (let i in nav_Option.childs) {
      if (option[nav_Option.childs[i].name]) {
        array_[nav_Option.childs[i].name] = option[nav_Option.childs[i].name].property
        if(!firstTab){
          firstTab = option[nav_Option.childs[i].name].property
        }
      }
    }

    return {tab:array_,firstTab:firstTab}
  }
}
